import { InvoiceStatus } from "@jugl-web/rest-api/invoices/models/common-types";
import { TableCell } from "@jugl-web/ui-kit/data-display/Table";
import { cx } from "@jugl-web/utils";

interface InvoicesStatusBadgeProps {
  status: InvoiceStatus;
}

const statusStyles: Record<InvoiceStatus, string> = {
  paid: "bg-[#CEF8E0] text-[#008F5D]",
  issued: "bg-[#E0F2FF] text-blue",
  partially_paid: "bg-[#FFECCC] text-orange-600",
  draft: "bg-white border border-solid border-grey text-grey",
  void: "bg-[#F5F5F5] text-grey",
  overdue: "bg-[#FFEBE7] text-[#EA3829]",
  pending: "bg-[#FFF4CC] text-[#B8860B]",
  long_term_due: "bg-[#FFD6CC] text-[#C0392B]",
};

const statusLabels: Record<InvoiceStatus, string> = {
  paid: "Paid",
  issued: "Issued",
  partially_paid: "Partially Paid",
  draft: "Draft",
  void: "Void",
  overdue: "Overdue",
  pending: "Pending",
  long_term_due: "Long Term Due",
};

export const InvoicesStatusBadge = ({ status }: InvoicesStatusBadgeProps) => (
  <TableCell>
    <span
      className={cx(
        "inline-block rounded-lg px-4 py-1.5 text-sm font-medium",
        statusStyles[status] || ""
      )}
    >
      {statusLabels[status] || status}
    </span>
  </TableCell>
);
